import { SxProps, Theme } from '@mui/material/styles';

/** Warm off-white page band — slightly deeper than pure white cards. */
export const PAGE_BAND_COLOR = '#f0eeea';

/** Shared max width for all page content on desktop. */
export const PAGE_MAX_WIDTH = { xs: '100%', md: '1400px' } as const;

/** Horizontal inset aligned with home hero and floating nav. */
export const pageColumnPx = { xs: 2, sm: 1.5, md: 4, lg: 5 } as const;

/** Outer wrapper for page content — full-bleed card on mobile, inset column on desktop. */
export const pageContainerSx: SxProps<Theme> = {
    width: '100%',
    maxWidth: PAGE_MAX_WIDTH,
    marginX: 'auto',
    mt: { xs: 0, md: 0 },
    mb: { xs: 0, md: 5 },
    px: { xs: 0, sm: 0, md: pageColumnPx.md, lg: pageColumnPx.lg },
    boxSizing: 'border-box',
};

/** White content card — edge-to-edge on mobile; padded card on desktop. */
export const contentPaperSx: SxProps<Theme> = {
    p: { xs: 2, sm: 2.5, md: 3 },
    borderRadius: { xs: 0, md: 3 },
    bgcolor: 'white',
    boxShadow: {
        xs: undefined,
        md: '0 8px 32px rgba(15, 23, 42, 0.07)',
    },
};

/**
 * Embed pages (e.g. JotForm) — same width as other pages; use embedContentPaperSx
 * and embedBleedSx for iframe-specific layout.
 */
export const embedPageContainerSx: SxProps<Theme> = {
    ...pageContainerSx,
    textAlign: 'left',
};

/** White card for embed pages — slightly less bottom padding before iframe. */
export const embedContentPaperSx: SxProps<Theme> = {
    ...contentPaperSx,
    pb: { xs: 2, md: 2 },
};

/**
 * Pulls an embed (iframe) toward the horizontal edges of embedContentPaperSx.
 * Pair with embedIframeSx on the iframe element.
 */
export const embedBleedSx: SxProps<Theme> = {
    mt: { xs: 2, md: 2.5 },
    mx: { xs: -2, sm: -2.5, md: -3 },
    width: { xs: 'calc(100% + 32px)', sm: 'calc(100% + 40px)', md: 'calc(100% + 48px)' },
};

/** Default iframe sizing for full-width embeds inside embedBleedSx. */
export const embedIframeSx: SxProps<Theme> = {
    display: 'block',
    width: '100%',
    minHeight: { xs: '1200px', md: 'calc(100vh - 260px)' },
    height: { xs: '1200px', md: 'calc(100vh - 260px)' },
    border: 'none',
    borderRadius: { xs: 0, md: 0 },
};
